module.exports = __webpack_public_path__ + "img/76388d5.png";